<script setup>
import { useApi, ApiError } from '@provise/composables/api'
import { useMessageStack } from '@provise/stores/messagestack'
import { useUserStore } from '@provise/stores/user'
import { reactive, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import PasswordInput from '@provise/components/password.vue'
import BlockScreen from '@provise/components/blockscreen.vue'
import config from '@/config'

const model = reactive({
  username: null,
  password: null,
  access_token: null,
  service: config.VITE_SERVICE_SELF,
})
const { user } = storeToRefs(useUserStore())
const { push: openModal } = useMessageStack()
const loading = ref(false)
const router = useRouter()

const { refresh: doLogin } = useApi({
  model,
  method: 'POST',
  url: 'login',
  transform: d => {
    delete d.access_token
    return d
  },
})

async function submit() {
  try {
    loading.value = true
    await doLogin()
    user.value = { ...user.value, access_token: model.access_token }
    router.push({ name: 'home' })
  } catch (err) {
    loading.value = false
    if (err instanceof ApiError && err.code === 401) {
      openModal({ type: 'error', message: 'Неправильный логин или пароль' })
    } else {
      openModal({ type: 'error', message: 'Произошла ошибка при попытке входа' })
    }
  }
}
</script>
<template>
  <Teleport
    to="body"
    v-if="loading"
  >
    <BlockScreen />
  </Teleport>
  <form
    @submit.prevent="submit"
    class="vstack gap-4"
  >
    <div class="form-field">
      <label class="form-label">Логин</label>
      <input
        type="text"
        class="form-control"
        name="username"
        v-model="model.username"
      />
    </div>
    <div class="form-field">
      <label class="form-label">Пароль</label>
      <PasswordInput
        name="password"
        v-model="model.password"
      />
    </div>
    <div class="hstack gap-3 justify">
      <button
        type="submit"
        class="btn btn-outline-primary flex-grow-1"
      >
        Войти
      </button>
      <RouterLink
        is="button"
        type="button"
        class="btn btn-outline-secondary flex-grow-1"
        :to="{ name: 'login' }"
      >
        Отмена
      </RouterLink>
    </div>
  </form>
</template>
